import { c as _c } from "react/compiler-runtime";
import PickContainer from '@pc/components/molecules/sidebar/PickContainer';
import { Suspense } from 'react';
import BJRankingContainer from './BJRankingContainer';
function RankingAndPickContainer() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Suspense fallback={null}><nav id="navigation"><BJRankingContainer /><PickContainer /></nav></Suspense>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export default RankingAndPickContainer;